import { render, staticRenderFns } from "./OrderPreviousDetail.vue?vue&type=template&id=45c183a0&"
import script from "./OrderPreviousDetail.vue?vue&type=script&lang=ts&"
export * from "./OrderPreviousDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports